define('viewmodels/Reporting/ExecutiveRiskDashboard',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger'],
    function (ko, router, app, appsecurity, navigation, system, logger) {
    var SRViewModel = {
        loadFindingReport: loadFindingReport,
        attached: attached,
        UserID: ko.observable()
    }
    return SRViewModel;

    function attached() {
        GetUser();
    }

    function GetUser() {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Reporting/GetUser",
                type: "GET",
                headers: headers,
            })
                .success(ajaxSuccess)
                .fail(function () {
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetUser() method in ExecutiveRiskDashboard.js';
            logger.logMessage(msg);
        }


        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult.ReportId != -999) {

                    SRViewModel.UserID(jsonResult);
                    loadFindingReport();
                }
                else {
                    logger.logError(jsonResult.ReportComments + ' - An error has occurred. Please contact the Application Administrator.', 'Error', system.getModuleId(ReportViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in ExecutiveRiskDashboard.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail() {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetUser() method in ExecutiveRiskDashboard.js';
            logger.logMessage(msg);
        }

    }
    function loadFindingReport() {
        $('#eRD_Report').html('');
        var homeurl = homeUrlLocation;
        var url = window.location.hash;
        $('<iframe>', {
            src: homeurl + 'SSRSExecutiveRiskDashboard.aspx?UserID=' + SRViewModel.UserID(),
            id: 'iframe_FINDINGS',
            frameborder: 0,
            style: 'display: block; width: 100%; height: 100%; min-height:480px; margin: 15px;',
        }).appendTo('#eRD_Report');
    }
});
